export default "<div class=\"news-bar\">\n  <strong>{{\"smf_maintenance_title\" | i18next }}</strong>\n  {{\"smf_maintenance_desc\" | i18next}}\n</div>\n"